/* eslint-disable react/require-default-props */
import { Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import React from 'react';

import './styles/main.scss';
import ToggleDrawerButton from './toggle_drawer_button';

const DevtoolsDrawer = (props) => {
  const {
    filtersDrawerOpen,
    selectedAssetKeys,
    toggleFiltersDrawer
  } = props;

  const devtoolsDrawerClass = filtersDrawerOpen === 'devtools' ? 'open' : '';

  return (
    <section className={`devtools-drawer-container ${devtoolsDrawerClass}`} data-cx-customization="devtools-drawer">
      <div className={`devtools-drawer-container-maxheight bf-scroll-element ${selectedAssetKeys.size ? 'select-bar-active' : ''}`}>
        <div className="devtools-toggle-tab">
          <ToggleDrawerButton toggleFiltersDrawer={toggleFiltersDrawer}>
            <p className="drawer-title modal-label"><Trans>DevTools</Trans></p>
          </ToggleDrawerButton>
        </div>
        <div className="devtools-expand-container bf-sticky-element">
          <p className="drawer-title modal-label"></p>
          <ToggleDrawerButton toggleFiltersDrawer={toggleFiltersDrawer} />
        </div>
        {filtersDrawerOpen === 'devtools' && (
          <div className="devtools-content">
            <div className="devtools-section">
              <h3>Semantic Search Developer Tools</h3>
              <p>Welcome to the DevTools drawer!</p>
              <div className="devtools-info">
                <p><strong>Feature Status:</strong> Semantic Search is enabled</p>
                <p><strong>Current Page:</strong> {BFG.resource.type}</p>
                <p><strong>Resource Name:</strong> {BFG.resource.name}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

DevtoolsDrawer.propTypes = {
  filtersDrawerOpen: PropTypes.oneOf(['labels', 'advanced-filters', 'devtools', 'none']).isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
  toggleFiltersDrawer: PropTypes.func.isRequired,
};

export default DevtoolsDrawer;
